import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "follow-up-rules-container" }
const _hoisted_2 = { class: "rules-list-container" }
const _hoisted_3 = { class: "rules" }
const _hoisted_4 = { class: "add-label" }
const _hoisted_5 = { class: "follow-up-rule" }

import Rule from './Rule.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import { RuleViewModel } from '../../models/ruleViewModel';
import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import TagBox from '@/shared/components/TagBox.vue';
import CapableAppPicker from '@/shared/components/capableAppPicker/CapableAppPicker.vue';
import { ConfigRequest } from '@/shared/components/capableAppPicker/configRequest';
import { BotActionAppViewModel } from '@/features/bots/models';
import { PropType, ref, watch } from 'vue';
import { IConditionsManager } from '@shared/components/conditions/models/conditionsManager';
import useVuelidate from '@vuelidate/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'RulesList',
  props: {
  configRequest: {
    type: Function as PropType<() => Promise<ConfigRequest>>,
    required: true,
  },
  rules: {
    type: Array as PropType<RuleViewModel[]>,
    default: [],
  },
  selectedApps: {
    type: Array as PropType<Array<ConfiguredAppIntegration>>,
    default: [],
  },
  ruleConditionsManager: {
    type: Object as PropType<IConditionsManager>,
    required: true,
  },
},
  emits: ["rules-updated", "followup-action-change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({
  areRulesAreValid,
});

const providedRules = ref<RuleViewModel[]>([]);
const ruleInvalidStates = ref<boolean[]>([]);
const hasInvalidRuleConditions = ref(false);

watch(
  () => props.rules,
  (value: RuleViewModel[]) => {
    if (value && value.length > 0) {
      providedRules.value = value;
    }
  },
  { immediate: true, deep: true },
);

function addRule() {
  const rule = {
    conditions: {
      type: 'and',
      conditions: [],
    },
    actions: [],
  };
  providedRules.value.push(rule);
  ruleUpdated(providedRules.value.length - 1, rule, hasAnyInvalidRules());
}

function ruleUpdated(index: number, rule: RuleViewModel, hasInvalidConditions: boolean) {
  providedRules.value[index] = rule;
  ruleInvalidStates.value[index] = hasInvalidConditions;
  hasInvalidRuleConditions.value = hasAnyInvalidRules();

  emit('rules-updated', providedRules.value);
}

function selectedFollowUpActionsChanged(selectedApps: BotActionAppViewModel[]) {
  emit('followup-action-change', selectedApps);
}

function deleteRule(index: number) {
  providedRules.value.splice(index, 1);
}

const $v = useVuelidate();

function areRulesAreValid() {
  return !hasInvalidRuleConditions.value && !$v.value.$invalid;
}

function hasAnyInvalidRules() {
  return ruleInvalidStates.value.some((invalid: boolean) => invalid);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "rules-message" }, "Attendant can follow up with leads who match the following rules", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providedRules.value, (rule, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(Rule, {
              class: "rule",
              rule: rule,
              "rule-conditions-manager": __props.ruleConditionsManager,
              onUpdated: 
              (rule, hasInvalidConditions) => ruleUpdated(index, rule, hasInvalidConditions)
            ,
              onDeleted: ($event: any) => (deleteRule(index))
            }, null, 8, ["rule", "rule-conditions-manager", "onUpdated", "onDeleted"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", { onClick: addRule }, [
            _createVNode(AddIcon),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "add-rule-label" }, "Add rule", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TagBox, {
        value: __props.rules.length > 0 ? 'else' : 'always'
      }, null, 8, ["value"]),
      _createVNode(CapableAppPicker, {
        modalHeading: 'Bot Apps',
        capability: 'botActions',
        "selected-apps": __props.selectedApps,
        isLozengeMode: true,
        configRequest: __props.configRequest,
        onChange: selectedFollowUpActionsChanged
      }, null, 8, ["selected-apps", "configRequest"])
    ])
  ]))
}
}

})